import React from 'react';
import EnvioCorreo from './componentes/envioCorreo';
import Login from './componentes/Login';
import Busqueda from './componentes/busqueda';
import Header from './componentes/Headers';
import ListadoPaciente from './componentes/ListadoPaciente';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import FootePie from './componentes/footer';
import ordenPacientes from './componentes/ordenespaciente';
import registroPaciente from './componentes/registropaciente';
import Derivantes from './componentes/derivantes';


function App() {

  

  return(

  <Router>
       

          <div className="container">
          <Header />
              <Switch>
               
                  <Route  path="/" exact  component={Busqueda}  />
                  <Route exact path="/EnvioCorreo" component={EnvioCorreo}  />
                  <Route exact path="/ordenpaciente" component={ordenPacientes}  />
                  <Route exact path="/busqueda" component={Busqueda}  />
                  <Route exact path="/listadopaciente" component={ListadoPaciente}  />
                  <Route exact path="/registroPaciente" component={registroPaciente}  />
                  <Route path="/derivantes" exact component={Derivantes}  />
              
              </Switch>
          </div>
  
    </Router>
    

  );
}
export default App;

